module.exports = __webpack_public_path__ + "static/img/bus-img.d6fb1935.png";